import React, { useEffect, useState } from 'react';

const HowToIncrease = () => {

  const [isOpen, setIsOpen] = useState(false);


   // === NOUVEAU AADS ADAPTATIF (mobile + desktop) ===
useEffect(() => {
  const div = document.createElement("div");
  div.innerHTML = `
    <!-- BEGIN AADS AD UNIT 2425494 -->
    
    </div>
    <!-- END AADS AD UNIT 2425494 -->
  `;
  document.body.appendChild(div);
  return () => document.body.removeChild(div);
}, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans overflow-hidden">
      {/* NAVBAR - exact same as Home, Leaderboard & Submit */}
      <header className="bg-gray-900/95 backdrop-blur-xl border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl 2xl:max-w-none mx-auto px-4 sm:px-6 2xl:px-10 py-4 sm:py-5">
          <div className="flex items-center justify-between">
            
            {/* Logo + Hamburger (visible seulement mobile) */}
            <div className="flex items-center gap-4">
              <img 
                src="/bannerRank.png" 
                alt="RankMyBanner" 
                className="h-9 sm:h-10 w-auto drop-shadow-[0_0_15px_rgb(16,185,129)]" 
              />
              
              {/* Hamburger - visible < md */}
              <button 
                type="button" 
                className="md:hidden text-emerald-400 focus:outline-none"
                aria-label="Toggle menu"
                onClick={() => setIsOpen(!isOpen)}
              >
                {/* SVG hamburger ou croix selon isOpen */}
                  {isOpen ? (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
              </button>
            </div>

            {/* Navigation */}
            <nav
                  className={`
                    ${isOpen ? 'block' : 'hidden'}              // affiche/cache sur mobile quand on clique
                    md:flex md:items-center                     // sur desktop → toujours visible + flex horizontal
                    absolute md:static top-full left-0 right-0  // position absolute sur mobile pour dropdown
                    bg-gray-900/95 md:bg-transparent            // fond sombre sur mobile, transparent sur desktop
                    border-b border-gray-800 md:border-none     // bordure basse sur mobile uniquement
                    p-6 md:p-0                                  // padding plus important sur mobile
                    flex flex-col md:flex-row                   // colonne sur mobile, ligne sur desktop
                    gap-6 md:gap-x-8 md:gap-y-0                 // espacement adapté
                    text-sm font-medium                         // style texte
                    z-40                                        // au-dessus du reste si besoin
                  `}
                >
              <a href="/" className="hover:text-emerald-400 transition hover:text-emerald-300">Home</a>
              <a href="/leaderboard" className="hover:text-emerald-400 font-semibold transition">Leaderboard</a>
              <a href="/submit" className="hover:text-emerald-400 transition">Submit Your Banner</a>
              <a href="/claim" className="hover:text-emerald-400 transition">Claim Points</a>
              <a href="/how-to-increase" className="text-emerald-400 transition">How to Increase</a>
            </nav>

            {/* Pub – cachée sur < 2xl */}
            <div className="hidden 2xl:block flex-shrink-0">
              <iframe 
                src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
                width="728" 
                height="90" 
                scrolling="no" 
                border="0" 
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </header>

      {/* HERO - massive cyber style */}
      <section className="relative py-28 bg-gradient-to-br from-gray-950 via-black to-gray-900 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
          <div className="inline-flex items-center gap-3 bg-emerald-500/10 border border-emerald-500/30 px-8 py-3 rounded-3xl text-emerald-400 font-medium mb-8 shadow-[0_0_30px_rgb(16,185,129,0.3)]">
            <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse" /> 
            PROVEN 2026 STRATEGIES
          </div>

          <h1 className="text-6xl md:text-7xl lg:text-8xl font-black tracking-[-3px] leading-none mb-8 bg-clip-text text-transparent bg-gradient-to-r from-white via-emerald-200 to-teal-300">
            HOW TO EXPLODE<br />YOUR BANNER TRAFFIC
          </h1>

          <p className="text-2xl text-gray-400 max-w-3xl mx-auto">
            Real tactics. Zero shortcuts. The exact methods used by every banner in the Top 10.
          </p>
        </div>
      </section>

      {/* POINTS SYSTEM */}
      <section className="py-24 bg-gray-900">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-5xl font-black text-center mb-16 tracking-tight">1. HOW POINTS ACTUALLY WORK</h2>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { emoji: "🔗", title: "Unique visits = points", desc: "Every new visitor from a different IP adds +1 point. Real traffic only." },
              { emoji: "⏱️", title: "Real-time updates", desc: "Points update instantly. Rankings refresh every hour." },
              { emoji: "🏆", title: "Monthly reset", desc: "Everything resets on the 1st. Inactive banners (60+ days) are removed." }
            ].map((item, i) => (
              <div key={i} className="group bg-gray-950 border border-gray-800 rounded-3xl p-10 hover:border-emerald-500 transition-all hover:-translate-y-3">
                <div className="text-7xl mb-8 group-hover:scale-110 transition">{item.emoji}</div>
                <h3 className="text-3xl font-bold mb-4 text-emerald-400">{item.title}</h3>
                <p className="text-gray-400 text-lg leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7 STRATEGIES - cyber timeline style */}
      <section className="py-24 bg-black">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-5xl font-black text-center mb-20 tracking-tight">2. 7 PROVEN WAYS TO GROW REAL TRAFFIC IN 2026</h2>

          <div className="space-y-20">
            {/* Strategy 1 */}
            <div className="flex flex-col lg:flex-row gap-12 items-center">
              <div className="lg:w-1/2">
                <div className="text-8xl font-black text-emerald-500/10 mb-6">01</div>
                <h3 className="text-4xl font-bold mb-6">Master Social Media Promotion</h3>
                <p className="text-gray-400 text-lg leading-relaxed mb-8">
                  Post consistently where crypto and banner enthusiasts hang out. Share your banner with strong visuals and clear calls-to-action.
                </p>
                <ul className="space-y-4 text-gray-400">
                  <li className="flex gap-4 items-start"><span className="text-emerald-400 text-2xl mt-1">✓</span> Create X/Twitter threads showcasing your banner</li>
                  <li className="flex gap-4 items-start"><span className="text-emerald-400 text-2xl mt-1">✓</span> Join Reddit (r/cryptocurrency, r/banners)</li>
                  <li className="flex gap-4 items-start"><span className="text-emerald-400 text-2xl mt-1">✓</span> Engage in Discord & Telegram groups</li>
                </ul>
              </div>
              <div className="lg:w-1/2 bg-gradient-to-br from-gray-900 to-black border border-emerald-500/20 rounded-3xl p-12 text-center">
                <p className="text-7xl font-black text-emerald-400">2,000+</p>
                <p className="text-sm tracking-[3px] uppercase text-gray-500">real visitors per strong campaign</p>
              </div>
            </div>

            {/* Strategy 2 */}
            <div className="flex flex-col lg:flex-row gap-12 items-center">
              <div className="lg:w-1/2 order-2 lg:order-1 bg-gradient-to-br from-gray-900 to-black border border-emerald-500/20 rounded-3xl p-12 text-center">
                <p className="text-7xl font-black text-emerald-400">5,000+</p>
                <p className="text-sm tracking-[3px] uppercase text-gray-500">monthly visitors from SEO alone</p>
              </div>
              <div className="lg:w-1/2 order-1 lg:order-2">
                <div className="text-8xl font-black text-emerald-500/10 mb-6">02</div>
                <h3 className="text-4xl font-bold mb-6">Optimize for Search Engines</h3>
                <p className="text-gray-400 text-lg leading-relaxed">
                  Write blog posts and guides around keywords like “best banner promotion 2026” or “crypto traffic tips”. Use Google Keyword Planner.
                </p>
              </div>
            </div>

            {/* Strategy 3 */}
            <div className="flex flex-col lg:flex-row gap-12 items-center">
              <div className="lg:w-1/2">
                <div className="text-8xl font-black text-emerald-500/10 mb-6">03</div>
                <h3 className="text-4xl font-bold mb-6">Create High-Quality Content</h3>
                <p className="text-gray-400 text-lg leading-relaxed mb-8">
                  Turn your banner into a story. Share case studies, design tips, or success stories from top banners.
                </p>
                <div className="grid grid-cols-2 gap-6">
                  <div className="bg-gray-900 border border-gray-800 p-6 rounded-2xl">Banner design tutorials</div>
                  <div className="bg-gray-900 border border-gray-800 p-6 rounded-2xl">Monthly traffic reports</div>
                  <div className="bg-gray-900 border border-gray-800 p-6 rounded-2xl">Crypto marketing guides</div>
                  <div className="bg-gray-900 border border-gray-800 p-6 rounded-2xl">Before/after examples</div>
                </div>
              </div>
              <div className="lg:w-1/2 flex justify-center">
                <div className="border-4 border-dashed border-emerald-500/30 rounded-3xl w-[520px] h-[110px] flex items-center justify-center bg-gray-950">
                  <span className="text-gray-400 italic">Your next viral guide goes here</span>
                </div>
              </div>
            </div>

            {/* Remaining 4 strategies - compact grid */}
            <div className="grid md:grid-cols-2 gap-8 pt-12">
              {[
                { num: "04", title: "Build Real Partnerships", desc: "Reach out to other banner owners or crypto projects. Offer mutual shoutouts or joint giveaways." },
                { num: "05", title: "Track Everything", desc: "Use Google Analytics, Bitly, or UTM links to see exactly what channels bring the best traffic." },
                { num: "06", title: "Stay Consistent", desc: "Post daily or every other day. One strong thread can bring hundreds of visitors for weeks." },
                { num: "07", title: "Focus on Quality", desc: "Avoid shortcuts. Real visitors click, stay, and come back — exactly what advertisers love." }
              ].map((s, i) => (
                <div key={i} className="bg-gray-950 border border-gray-800 rounded-3xl p-10 hover:border-emerald-500 transition-all group">
                  <div className="text-6xl font-black text-emerald-500/10 group-hover:text-emerald-500/30 mb-4">{s.num}</div>
                  <h4 className="text-2xl font-bold mb-4">{s.title}</h4>
                  <p className="text-gray-400">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <div className="py-28 bg-gradient-to-r from-emerald-950 via-black to-teal-950 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-6xl font-black tracking-tight mb-8">START GROWING REAL TRAFFIC TODAY</h2>
          <p className="text-2xl text-gray-400 max-w-2xl mx-auto mb-12">
            The Top 10 banners all use these exact strategies. Quality traffic = higher ranking + better results.
          </p>
          <a
            href="/submit"
            className="inline-block px-16 py-7 text-2xl font-bold bg-white text-black rounded-3xl hover:bg-emerald-400 hover:text-black transition-all scale-105 shadow-[0_0_60px_rgb(16,185,129)]"
          >
            SUBMIT YOUR BANNER &amp; GET STARTED
          </a>
        </div>
      </div>

      {/* ZeroAds bottom banner */}
      <div className="flex justify-center py-12 bg-gray-900">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" height="90" scrolling="no" border="0" frameBorder="0"
        />
      </div>

      {/* FOOTER - exact same as all other pages */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-gray-500">
            <div>© 2026 RankMyBanner • All Rights Reserved</div>
            <div className="flex gap-8">
              <a href="/" className="hover:text-gray-300">Home</a>
              <a href="/leaderboard" className="hover:text-gray-300">Leaderboard</a>
              <a href="/submit" className="hover:text-gray-300">Submit Your Banner</a>
              <a href="/claim" className="hover:text-gray-300">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-gray-300">How to Increase</a>
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HowToIncrease;